import Link from "next/link";
import { useState } from "react";
import { newsletterTypes } from "../../../../../common/constants";
import Select from "../../../../components/Select/Select";

interface HeroProps {
    title: string;
    tags: { title: string }[];
    city: {
        title: string;
    };
    subheading: string;
}

export default function Hero({ title, tags, subheading, city }: HeroProps) {
    return (
        <section className="bg-gray-light">
            <div className="pt-16 pb-24 md:py-28 md:pb-32 text-center max-w-screen-sm m-auto px-6 lg:px-0">
                <p className="font-medium text-primary-600">{subheading}</p>

                <h1 className="md:text-4xl leading-tight pt-4 pb-6 font-semibold text-primary-900">
                    {title}
                </h1>
                <div className="flex justify-center">
                    {tags.map((tag) => (
                        <span className="text-green-700 bg-green-100 px-3 py-1 rounded-full text-sm font-medium mr-2">
                            {tag.title}
                        </span>
                    ))}
                    <span className="text-primary-700 bg-primary-50 px-3 py-1 rounded-full text-sm font-medium">
                        {city?.title}
                    </span>
                </div>
            </div>
        </section>
    );
}
